/**
 * Counts from GET /notify/notification_center/counters (by_table).
 */

export function getTabNotificationCount(byTable, tabId) {
  if (!byTable || typeof byTable !== "object") {
    return 0;
  }
  return Number(byTable[tabId]) || 0;
}

/**
 * @param {Record<string, number>} byTable
 * @param {import('../config/notificationCenterConfig').NotificationCenterTabDef[]} tabs
 */
export function buildNotificationCenterTabCounts(byTable, tabs) {
  if (!Array.isArray(tabs)) {
    return [];
  }

  return tabs.map((tab) => ({
    tabId: tab.id,
    label: tab.content ?? tab.labelKey ?? tab.id,
    count: getTabNotificationCount(byTable, tab.id),
  }));
}

export function formatNotificationCenterCount(count) {
  if (count == null || Number.isNaN(Number(count))) {
    return "—";
  }
  return new Intl.NumberFormat("en-US").format(Number(count));
}

/** Compact count for badges (bell, tabs). Returns null when zero. */
export function formatNotificationCenterBadgeCount(count) {
  const value = Number(count);
  if (!value || Number.isNaN(value) || value <= 0) {
    return null;
  }
  if (value >= 99) {
    return "99+";
  }
  return String(value);
}

/**
 * Badge urgency tone for notification counts.
 * 0 — hidden | 1–9 info | 10–49 warning | 50+ critical.
 * @returns {'none' | 'info' | 'warning' | 'critical'}
 */
export function getNotificationBadgeTone(count) {
  const value = Number(count);
  if (!value || Number.isNaN(value) || value <= 0) {
    return "none";
  }
  if (value >= 50) {
    return "critical";
  }
  if (value >= 10) {
    return "warning";
  }
  return "info";
}
